import { connect } from "react-redux";

import { getErrorPayload } from "domain/Game/selectors";
import { getGameTypeById } from "domain/Directories/selectors";
import Component from "./Component";

const mapStateToProps = (state) => {
    const errorData = getErrorPayload(state);

    return {
        gameType: getGameTypeById(state, errorData.type_id),
    };
};

export default connect(mapStateToProps)(Component);
